import * as React from 'react'
class MdButton extends React.Component<MdButtonProps, null> {

  constructor(props: any) {
    super(props)
  }

  public render() {
    return (
      <a
        onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            this.props.clickHandler()
          }
        }
        style={this.props.style}
        className={'md-button ' + (this.props.checkmark ? 'checkmark' : null) }
      >{this.props.text}</a>
    )
  }
}

export default MdButton



// WEBPACK FOOTER //
// ./react/components/widgets/MdButton.tsx